module.exports = __webpack_public_path__ + "img/schlosserei-halle.1019466f.jpg";